export default __webpack_public_path__ + "static/safari-pinned-tab.svg";